import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { StatusBarBehavior as statusEnum } from "@vmosolutions/oc-interfaces";
import { useCallback } from "react";

interface IStatusBarBehaviorProps {
  focusedButton: string;
  setFocusedButton: React.Dispatch<React.SetStateAction<statusEnum>>;
}

const StatusBarBehavior = (props: IStatusBarBehaviorProps): JSX.Element => {
  const { focusedButton, setFocusedButton } = props;

  const handleChange = useCallback(
    (event: React.MouseEvent<HTMLElement>, newVal: React.SetStateAction<statusEnum>) => {
      if (newVal) setFocusedButton(newVal);
    },
    [setFocusedButton]
  );

  return (
    <ToggleButtonGroup value={focusedButton} exclusive onChange={handleChange}>
      <ToggleButton value={statusEnum.Sticky}>On-Click</ToggleButton>
      <ToggleButton value={statusEnum.Hover}>On-Hover</ToggleButton>
    </ToggleButtonGroup>
  );
};

export { StatusBarBehavior };
